import { useContext, useState, ChangeEventHandler } from "react";
import { useForm } from "react-hook-form";
import useAppNavigate from "../router/use-app-navigate";
import CustomerApi from "../../api/customer";
import UploadApi from "../../api/upload";
import AuthContext from "../auth-context";
import Filebox from "../inputs/filebox";
import Form from "../inputs/form";
import Submit from "../inputs/submit";
import Skip from "../inputs/skip";
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import PurchaseTicketApi from "../../api/purchase-ticket";

import { useTranslation } from "react-i18next";

interface UploadForm {
  imageId: string;
}

export default function UploadImage() {
  const context = useContext(AuthContext);
  const { t } = useTranslation(undefined, {
    keyPrefix: "SignUp",
  });

  const { handleSubmit } = useForm<UploadForm>();
  const navigate = useAppNavigate();
  const [fileId, setFileId] = useState<number | undefined>();
  const [imagePreview, setImagePreview] = useState<string | undefined>();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { userData } = context;

  const purchaseHandler = () => {
    const productId = searchParams.get("productId");
    if (productId) {
      new PurchaseTicketApi(context)
        .post(context.activeFileId!, +productId, context.customerData!.type)
        .then((ticket) => {
          if (ticket.errorMessage) navigate(`/signup/purchase`);
          else {
            new PurchaseTicketApi(context)
              .getAll()
              .then(context.setTickets)
              .catch(() => {});
            navigate(`/signup/payment/${ticket.id}`);
          }
        })
        .catch(() => navigate(`/signup/purchase`));
    } else navigate(`/signup/purchase`);
  };

  const onSubmit: () => Promise<string> = () => {
    return new CustomerApi(context)
      .put({
        nationalCardImageId: fileId,
      })
      .then(({ errorMessage }: { errorMessage: string }) => {
        if (!errorMessage) {
          location.pathname === "/signup/ngn/uploadImage"
            ? navigate(`/signup/ngn/selectLine/`)
            : purchaseHandler();
        } else {
          setErrorMessage(errorMessage);
        }
        return errorMessage;
      });
  };

  const onFileChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    if (event.target.files) {
      const file = event.target.files[0];
      if (file) {
        const fileSizeInBytes = file.size;
        const fileSizeInMegabytes = fileSizeInBytes / (1024 * 1024);
        if (fileSizeInMegabytes > 2) {
          setErrorMessage(t("File size exceeds 2 megabytes"));
          return;
        }
        setErrorMessage("");
        setLoading(true);

        // console.log("context", context);
        var uploadApi = new UploadApi(context);
        uploadApi.post(file).then((fileId) => {
          // console.log("fileId", fileId);
          setFileId(fileId);
          const previewURL = URL.createObjectURL(file);
          setImagePreview(previewURL);
          setLoading(false);
        });
      }
    }
  };

  const handleSkip = () => {
    if (location.pathname === "/signup/ngn/uploadImage") {
      navigate(`/signup/ngn/selectLine/`);
    } else {
      purchaseHandler();
    }
  };

  return (
    <Form submit={onSubmit} handleSubmit={handleSubmit}>
      <div className="flex flex-wrap md:flex-no-wrap justify-center pt-8">
        <Filebox name="file" onChange={onFileChange} label="تصویر کارت ملی:" />
        {errorMessage && <div className="text-red-500">{errorMessage}</div>}
        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                className="w-full h-auto max-w-xs max-h-xs  pt-4 md:pt-8"
              />
            )}
          </>
        )}
      </div>
      <Submit />
      {userData?.isSupportUser && <Skip onClick={handleSkip} />}
    </Form>
  );
}
